import { render, staticRenderFns } from "./AdminProfile.vue?vue&type=template&id=5e24a944&scoped=true"
import script from "./AdminProfile.vue?vue&type=script&lang=js"
export * from "./AdminProfile.vue?vue&type=script&lang=js"
import style0 from "./AdminProfile.vue?vue&type=style&index=0&id=5e24a944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e24a944",
  null
  
)

export default component.exports